export default __webpack_public_path__ + "guide--vector-tiles-standards-wo-3-960-99391011b1977a995732ff9330d28f63.png";